import React from 'react';
import { Container } from '@mui/material';
import SessionNoteSummarizer from '../components/SessionNoteSummarizer';

const SessionNoteSummarizerPage = () => {
  return (
    <Container maxWidth="md" sx={{ py: 4 }}>
      <SessionNoteSummarizer />
    </Container>
  );
};

export default SessionNoteSummarizerPage;